<template>
    <div 
        v-if="!isMobile() && left"
        v-html="cursor" 
        :class="{ 'scale-125': link, 'text-4xl': !small, 'text-2xl': small }"
        class="font-serif transition-transform duration-300 mix-blend-exclusion text-white hidden sm:block pointer-events-none fixed transform -translate-x-1/2 -translate-y-1/2 z-50"
        :style="{ top: y, left: x }"
    />
</template>

<script>
export default {
    data() {
        return {
            default: "&#x25CF;",
            cursor: "",
            link: false,
            small: false,
            left: false,
            x: 0,
            y: 0,
        }
    },
    mounted() {
        this.cursor = this.default;
        window.addEventListener('mousemove', (event) => {
            this.x = event.clientX + 'px';
            this.y = event.clientY + 'px';
        });
        this.$root.$on('linkCursor', () => {
            this.link = true;
        });
        this.$root.$on('changeCursor', this.updateCursor);
        this.$root.$on('resetCursor', () => {
            this.cursor = this.default;
            this.link = false;
            this.small = false;
        });
        document.addEventListener('mousemove', () => {
            this.left = true;
        })
        document.addEventListener('mouseleave', () => {
            this.left = false;
        })
    },
    methods: {
        isMobile() {
            if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                return true
            } else {
                return false
            }
        },
        updateCursor(val) {
            this.cursor = val;
            if(val == '&#x25C0;' || val == '&#x25B6;') {
                this.small = true;
            } else {
                this.small = false;
            }
        }
    }
}
</script>